import { createApp } from '@app/adapters/create-app'
import { VueElementConstructor } from 'vue'
import { VueModalInstance } from '../types'

export const mountVueModalInstance = (
  Modal: VueElementConstructor,
  target: HTMLElement | undefined
): VueModalInstance => {
  const modalApp = createApp(
    Modal,
    {},
    {
      singletonId: 'modal-citizen-vue-modal',
    }
  )

  return modalApp.mount(
    target || document.createElement('div')
  ) as VueModalInstance
}
